import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'currencyOrDefault' })
export class CurrencyOrDefaultPipe implements PipeTransform {
  private currencyPipe: CurrencyPipe = new CurrencyPipe('en-US');
  private decimalPipe: DecimalPipe = new DecimalPipe('en-US');

  transform(value: string,
            currencyCode = 'USD',
            symbolDisplay = true,
            digits = '1.2-2',
            defaultString = ''): string {
    let currencyString: string =   defaultString;
    value = this.stripNonNumericChars(value);
    let numberValue: number = parseFloat(value);
    if (numberValue !== null && !isNaN(numberValue) && numberValue !== 0) {
      currencyString = this.currencyPipe.transform(numberValue, currencyCode, symbolDisplay ? 'symbol' : '', digits);
    }

    return currencyString;
  }

  parse(value: string,
        noChange = false): string {

    value = this.stripNonNumericChars(value);

    if (!isNaN(parseFloat(value)) && !noChange) {
      return this.decimalPipe.transform(value, '1.2-2');
    }   else if (!isNaN(parseInt(value, 10)) && noChange) {
      let roundedValue: string = Math.round(parseFloat(value)) + '';
      return parseInt(roundedValue, 10) + '';
    }

    return '';
  }

  stripNonNumericChars(value: string | number): string {
    let strValue: string = value + '';
    return strValue.replace(/[,$]/g, '');
  }
}
